import { render, staticRenderFns } from "./Form9ProcessHeader.vue?vue&type=template&id=fb7b30ce&scoped=true"
import script from "./Form9ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form9ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form9ProcessHeader.vue?vue&type=style&index=0&id=fb7b30ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7b30ce",
  null
  
)

export default component.exports